import { useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { UserContext } from '../../context';
import { isVendorPartner } from '../../helpers';

export const RedirectUser = () => {
  const { user, isLoading } = useContext(UserContext);
  const { state, search }: { state: any; search: string } = useLocation();

  if (user && !isLoading) {
    if (isVendorPartner(user)) {
      return <Redirect to={state?.from ?? `/vendors${search}`} />;
    }
    // '/?query=string' is the default redirect if no state is provided. https://stackoverflow.com/questions/2388920/query-string-after-the-domain-name
    return <Redirect to={state?.from ?? `/${search}`} />;
  }
  return null;
};
